import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/global.css'

// 导入全局图片组件
import CommonImage from '@/components/CommonImage.vue'
import { handleImageError, getValidImageUrl } from '@/utils/imageHandler'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 全局注册图片组件
Vue.component('CommonImage', CommonImage)

// 全局混入图片处理方法
Vue.mixin({
  methods: {
    $handleImageError: handleImageError,
    $getValidImageUrl: getValidImageUrl
  }
})

// 全局错误处理 - 忽略 Vue Router 的重定向错误
Vue.config.errorHandler = (err, vm, info) => {
  if (err.name === 'NavigationRedirected' || 
      err.name === 'NavigationDuplicated' ||
      (err.message && err.message.includes('Redirected'))) {
    return
  }
  console.error(err, vm, info)
}

// 全局 Promise 错误处理
window.addEventListener('unhandledrejection', event => {
  const err = event.reason
  if (err.name === 'NavigationRedirected' || 
      err.name === 'NavigationDuplicated' ||
      (err.message && err.message.includes('Redirected'))) {
    event.preventDefault()
    return
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')